var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ── TATO ──────────────────────────────────────────────────────────────
     navigator.vibrate só existe no Android/Chrome — o Safari do iPhone não
     implementa, e não há substituto na web. Além disso o navegador exige
     que a pessoa já tenha tocado na página: rolar não conta. Então isto é
     enfeite que some sozinho onde não pode existir, nunca dependência.     */
  var Tato = (function(){
    var existe = !!(navigator && typeof navigator.vibrate === 'function');
    var interagiu = false;
    ['pointerdown','keydown','touchstart'].forEach(function(t){
      document.addEventListener(t, function(){ interagiu = true; }, { once: true, passive: true });
    });
    function toque(p){
      if (!existe || REDUCE || !interagiu) return;
      try { navigator.vibrate(p); } catch (_) {}
    }

    /* CAMADA iOS — técnica 01 da Biblioteca Ryse.
       O Safari não expõe vibração nenhuma para o site. Mas o switch nativo
       (`<input type="checkbox" switch>`) vibra por design quando o dedo o
       aciona. Escondendo um switch transparente por cima do botão, o toque
       cai nele, o iPhone vibra, e o clique segue subindo para o botão.
       Vale só para toque direto: chamar por código não vibra — a Apple
       fechou essa porta no iOS 26.5. */
    var ALVOS = '.btn, #buypill .cbuy, [data-topen], .cmpx-bt a.fill, ' +
                '.closing .cbtns a, .faqx-support a, ' +
                /* decisoes que a pessoa toma com o dedo e quer sentir:
                   a voltagem, o card que vira, a gaveta do frete, o botao
                   que cota, e o convite da calculadora. `:not([disabled])`
                   porque o lado esgotado do switch nao pode vibrar. */
                '.cpr-esc:not([disabled]), .cpr-card-vira, .cpr-frete-abre, ' +
                '[data-frete-ir], .dhl-play';
    function equipar(raiz){
      if (REDUCE) return;
      var lista = (raiz || document).querySelectorAll(ALVOS);
      for (var i = 0; i < lista.length; i++){
        var el = lista[i];
        if (el.querySelector('.tato-sw')) continue;
        el.classList.add('tato');
        var sw = document.createElement('input');
        sw.type = 'checkbox';
        sw.setAttribute('switch', '');        /* atributo nativo iOS */
        sw.className = 'tato-sw';
        sw.setAttribute('aria-hidden', 'true');
        sw.tabIndex = -1;
        /* O switch engole a ativação do link: o clique bate nele e o <a> não
           navega mais. Testado — em <button> o clique sobe normal, em <a> não.
           Então em link a gente refaz a navegação na mão. */
        if (el.tagName === 'A'){
          (function(alvo){
            sw.addEventListener('click', function(){
              var href = alvo.getAttribute('href');
              if (!href || href === '#') return;
              if (alvo.getAttribute('target') === '_blank') window.open(href, '_blank', 'noopener');
              else window.location.href = href;
            });
          })(el);
        }
        el.appendChild(sw);
      }
    }

    return {
      leve:    function(){ toque(8); },            /* abriu, fechou, escolheu */
      medio:   function(){ toque(16); },           /* ação de compra */
      chamada: function(){ toque([0, 12, 80, 20]); }, /* dois toques curtos: "olha aqui" */
      pronto:  function(){ return existe && !REDUCE && interagiu; },
      equipar: equipar
    };
  })();
  window.Tato = Tato;
  Tato.equipar();

  /* ── FOLHA: o comportamento comum dos painéis ──────────────────────────
     Trava a rolagem de um jeito que o iOS respeita, leva o foco pra dentro
     e devolve pra quem abriu, e no celular deixa arrastar pra fechar.      */
  var Folha = (function(){
    var abertos = [], yGuardado = 0, quemAbriu = null;

    /* Trava leve (10/2026): html.stl-trava-folha (regra no header-stellar) com overflow:hidden nao mexe
       no layout nem na rolagem, entao nao ha o que restaurar ao fechar. iOS < 16: caminho antigo (body fixed). */
    var TRAVA_LEVE = !!(window.CSS && CSS.supports && CSS.supports('overscroll-behavior', 'none'));
    function trava(){
      yGuardado = window.scrollY;
      if (TRAVA_LEVE) { document.documentElement.classList.add('stl-trava-folha'); return; }
      document.body.style.position = 'fixed';
      document.body.style.top = (-yGuardado) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }
    function destrava(){
      if (TRAVA_LEVE) { document.documentElement.classList.remove('stl-trava-folha'); return; }
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      /* A página tem `scroll-behavior: smooth`. Quando o body deixa de ser fixo,
         a rolagem volta a zero por um instante — e o smooth transformava a volta
         numa viagem animada do topo até aqui. Restaurar tem que ser instantâneo:
         'instant' ja vence o smooth; o inline no html so no navegador sem 'instant'. */
      try { window.scrollTo({ top: yGuardado, left: 0, behavior: 'instant' }); }
      catch (e) {
        var antes = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, yGuardado);
        document.documentElement.style.scrollBehavior = antes;
      }
    }

    function painel(m){ return m.querySelector('.rbox, .box'); }

    function abrir(m){
      if (m.classList.contains('open')) return;
      quemAbriu = document.activeElement;
      if (!abertos.length) trava();
      abertos.push(m);
      m.classList.add('open');
      m.setAttribute('aria-hidden', 'false');
      var x = m.querySelector('button[data-rclose],button[data-tclose],button[data-jclose]');
      if (x && x.focus) setTimeout(function(){ x.focus({ preventScroll: true }); }, 60);
    }

    function fechar(m){
      if (!m.classList.contains('open')) return;
      m.classList.remove('open');
      m.setAttribute('aria-hidden', 'true');
      var p = painel(m); if (p) p.style.transform = '';
      m.classList.remove('fol-arrastando');
      abertos = abertos.filter(function(o){ return o !== m; });
      if (!abertos.length) destrava();
      if (quemAbriu && quemAbriu.focus) { var qa = quemAbriu; requestAnimationFrame(function () { qa.focus({ preventScroll: true }); }); }
      quemAbriu = null;
    }

    /* ARRASTAR A FOLHA
       Pega em qualquer ponto dela, como numa folha nativa. Três guardas para
       não atropelar o resto:
       · começa fora de controle (deslizante, botão, link) — senão o dedo
         que ia mexer no ticket médio fechava o painel;
       · só assume o gesto se o conteúdo já estiver no topo da rolagem —
         no meio da leitura, quem manda é a rolagem;
       · precisa de 8px pra decidir, para não confundir toque com arrasto.   */
    function arrastavel(m){
      var p = painel(m); if (!p) return;
      var y0 = 0, dy = 0, t0 = 0, armado = false, ativo = false, idPonteiro = null;

      function emControle(alvo){
        return !!(alvo && alvo.closest && alvo.closest('input, button, a, select, textarea, .rfield'));
      }

      function comeco(e){
        if (window.innerWidth > 700 || ativo) return;
        if (emControle(e.target)) return;
        y0 = e.clientY; dy = 0; t0 = e.timeStamp; armado = true; idPonteiro = e.pointerId;
        m.classList.remove('fol-voltando');
      }

      function mover(e){
        if (!armado || e.pointerId !== idPonteiro) return;
        var d = e.clientY - y0;
        if (!ativo){
          if (d > 8 && p.scrollTop <= 0){
            ativo = true;
            m.classList.add('fol-arrastando');
            try { p.setPointerCapture(idPonteiro); } catch (_) {}
          } else if (Math.abs(d) > 8){
            armado = false;                       /* virou rolagem, não arrasto */
            return;
          } else return;
        }
        dy = Math.max(0, d);
        p.style.transform = 'translateY(' + dy + 'px)';
      }

      function solta(e){
        if (!armado) return;
        armado = false;
        if (!ativo) return;
        ativo = false;
        m.classList.remove('fol-arrastando');
        var v = dy / Math.max(1, (e.timeStamp - t0));       /* px por ms */
        if (dy > p.offsetHeight * 0.26 || v > 0.6){
          p.style.transform = '';
          if (window.Tato) window.Tato.leve();
          fechar(m);
        } else {
          m.classList.add('fol-voltando');
          p.style.transform = '';
          setTimeout(function(){ m.classList.remove('fol-voltando'); }, 320);
        }
      }

      p.addEventListener('pointerdown', comeco);
      p.addEventListener('pointermove', mover);
      p.addEventListener('pointerup', solta);
      p.addEventListener('pointercancel', solta);
      /* enquanto o arrasto manda, o navegador não pode rolar por baixo */
      p.addEventListener('touchmove', function(e){ if (ativo && e.cancelable) e.preventDefault(); }, { passive: false });
    }

    /* Tab não pode escapar pra página que está atrás */
    document.addEventListener('keydown', function(e){
      if (e.key !== 'Tab' || !abertos.length) return;
      var m = abertos[abertos.length - 1];
      var focaveis = m.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var lista = [];
      for (var i = 0; i < focaveis.length; i++){
        var el = focaveis[i];
        if (!el.disabled && el.offsetParent !== null) lista.push(el);
      }
      if (!lista.length) return;
      var primeiro = lista[0], ultimo = lista[lista.length - 1];
      if (e.shiftKey && document.activeElement === primeiro){ e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo){ e.preventDefault(); primeiro.focus(); }
    });

    return { abrir: abrir, fechar: fechar, arrastavel: arrastavel };
  })();
  // Modal de ficha técnica
  (function(){
    var modal=document.getElementById('techmodal'); if(!modal) return;
    function open(){ Folha.abrir(modal); }
    function close(){ Folha.fechar(modal); }
    Folha.arrastavel(modal);
    document.querySelectorAll('[data-topen]').forEach(function(b){ b.addEventListener('click',open); });
    modal.querySelectorAll('[data-tclose]').forEach(function(b){ b.addEventListener('click',close); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&modal.classList.contains('open')) close(); });

    /* QUEM CHEGA POR #ficha JA QUER A FICHA.

       A ficha vive num painel, nao numa ancora: sem isto, um link de fora
       (e-mail, landing, anuncio) deposita a pessoa na pagina e ainda pede
       que ela ache o botao. O atraso curto deixa o layout assentar antes
       de o painel subir. `replaceState` limpa o hash pra que fechar o
       painel e recarregar nao o abra de novo. */
    function porHash(){
      if (location.hash !== '#ficha') return;
      setTimeout(function(){
        open();
        history.replaceState(null, '', location.pathname + location.search);
      }, 320);
    }
    porHash();
    window.addEventListener('hashchange', porHash);
  })();

  /* ── PAINEL GENERICO ───────────────────────────────────────────────────
     Qualquer gatilho com data-abre="id" abre o .tmodal daquele id, com o
     mesmo comportamento da ficha tecnica: arrastar pra fechar, Esc, clique
     fora, foco preso, rolagem travada. Assim um painel novo nao pede
     JavaScript novo — so a dupla botao/painel no Liquid.                  */
  (function(){
    var gatilhos = document.querySelectorAll('[data-abre]');
    if (!gatilhos.length) return;
    var equipados = [];
    Array.prototype.forEach.call(gatilhos, function(g){
      var m = document.getElementById(g.getAttribute('data-abre'));
      if (!m) return;
      if (equipados.indexOf(m) === -1){
        equipados.push(m);
        Folha.arrastavel(m);
        m.querySelectorAll('[data-tclose]').forEach(function(b){
          b.addEventListener('click', function(){ Folha.fechar(m); });
        });
      }
      g.addEventListener('click', function(){ Folha.abrir(m); });
    });
    document.addEventListener('keydown', function(e){
      if (e.key !== 'Escape') return;
      equipados.forEach(function(m){ if (m.classList.contains('open')) Folha.fechar(m); });
    });
  })();
  // Galeria
  (function(){
    var main=document.getElementById('galmain'), thumbs=document.getElementById('galthumbs');
    if(!main||!thumbs) return;
    thumbs.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        main.src=b.getAttribute('data-src');
        /* o ponto focal e por FOTO: trocar a imagem sem trocar o
           object-position deixaria a segunda enquadrada pela primeira */
        main.style.objectPosition=b.getAttribute('data-foco')||'';
        thumbs.querySelectorAll('button').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on');
      });
    });
  })();
  // Seletor de voltagem
  (function(){
    var box=document.getElementById('volt'), out=document.getElementById('voltsel'); if(!box) return;
    box.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        box.querySelectorAll('button').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on'); if(out) out.textContent=b.textContent.trim();
      });
    });
  })();
  // FAQ categorizado
  (function(){
    document.querySelectorAll('.qa button').forEach(function(b){b.addEventListener('click',function(){b.parentElement.classList.toggle('open');});});
    var cats=document.getElementById('faqcats'), list=document.getElementById('qalist');
    if(cats&&list){
      var items=list.querySelectorAll('.qa');
      function filter(cat){
        cats.querySelectorAll('button').forEach(function(b){b.classList.toggle('on',b.getAttribute('data-cat')===cat);});
        var first=true;
        items.forEach(function(q){
          var show=q.getAttribute('data-cat')===cat;
          q.hidden=!show; q.classList.remove('open');
          if(show&&first){ q.classList.add('open'); first=false; }
        });
      }
      cats.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){filter(b.getAttribute('data-cat'));});});
      filter('geral');
    }
  })();
  // Mini-slideshow da solução
  (function(){
    var box=document.getElementById('solhero'); if(!box) return;
    var slides=box.querySelectorAll('.sh-slide'), dots=box.querySelectorAll('.sh-dots button'), i=0, timer=null;
    if (slides.length < 2) return;      /* uma foto só não gira */
    function go(n){ i=(n+slides.length)%slides.length; slides.forEach(function(s,k){s.classList.toggle('on',k===i);}); dots.forEach(function(d,k){d.classList.toggle('on',k===i);}); }
    function start(){ if(REDUCE) return; stop(); timer=setInterval(function(){ go(i+1); },3800); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    dots.forEach(function(d,k){ d.addEventListener('click',function(){ go(k); start(); }); });
    box.addEventListener('mouseenter',stop); box.addEventListener('mouseleave',start);
    start();
  })();
  // Pílula flutuante de compra (aparece ao rolar)
  var cpbar=document.getElementById('buypill');
  var ticking=false, vh=window.innerHeight, dh=document.documentElement.scrollHeight;

  /* Cada gancho é um conteúdo e uma ação. O padrão é comprar; alguns blocos pedem outra coisa. */
  var SVG = {
    roi:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2.5" width="16" height="19" rx="3"/><path d="M8 7h8"/><path d="M8.5 12h.01M12 12h.01M15.5 12h.01M8.5 16h.01M12 16h.01M15.5 16v2"/></svg>',
    tech: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><circle cx="12" cy="8" r=".7" fill="currentColor" stroke="none"/></svg>',
    wa:   '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.3A10 10 0 1 0 12 2Zm0 18a8 8 0 0 1-4.1-1.1l-.3-.2-2.9.8.8-2.8-.2-.3A8 8 0 1 1 12 20Zm4.4-6c-.2-.1-1.4-.7-1.6-.8-.2-.1-.4-.1-.5.1-.2.2-.6.8-.7.9-.1.1-.3.2-.5.1a6.5 6.5 0 0 1-3.2-2.8c-.2-.4.2-.4.6-1.2.1-.1 0-.3 0-.4l-.7-1.7c-.2-.5-.4-.4-.5-.4h-.5a1 1 0 0 0-.7.3c-.3.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.8 2.8 4.4 3.8.6.3 1.1.4 1.5.5.6.2 1.1.2 1.6.1.5-.1 1.4-.6 1.6-1.1.2-.6.2-1 .1-1.1 0-.1-.2-.2-.4-.3Z"/></svg>',
    cmp:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M9 20V12"/><path d="M15.5 20V5"/></svg>'
  };
  var GANCHOS = {
    buy: {
      ic:  '<img src="https://stellarbeauty.com.br/cdn/shop/files/secador-stellar-rosa-frontal.png?v=1782659903&width=120" alt="">',
      tit: 'Secador Stellar PRO', sub: 'R$ 2.499,99 · 10x sem juros',
      cta: '<a class="cbuy" href="#comprar">Comprar</a>'
    },
    roi: {
      ic:  SVG.roi,
      tit: 'Quanto rende no seu salão?', sub: 'Faça a conta com os seus números',
      cta: '<button class="cbuy" type="button" data-act="roi">Calcular</button>'
    },
    tech: {
      ic:  SVG.tech,
      tit: 'Ficha técnica completa', sub: 'Motor, íons, potência e voltagem',
      cta: '<button class="cbuy" type="button" data-act="tech">Ver ficha</button>'
    },
    wa: {
      ic:  SVG.wa,
      tit: 'Ficou alguma dúvida?', sub: 'A gente responde rapidinho',
      cta: '<a class="cbuy" href="https://wa.me/5521990185421" target="_blank" rel="noopener">Falar agora</a>'
    },
    /* na seção dos dois modelos a pergunta que a pessoa está fazendo não é
       "compro?" — é "qual dos dois?". A pílula muda de assunto junto. */
    cmp: {
      ic:  SVG.cmp,
      tit: 'Stellar One ou PRO?', sub: 'As duas fichas, lado a lado',
      cta: '<button class="cbuy" type="button" data-act="cmp">Comparar</button>'
    }
  };

  /* o gancho "comprar" nao mora aqui: ele e o que o editor ja pintou na
     pilula no servidor. Ler do DOM deixa um dono so — antes a peca nascia
     com a foto e o preco do tema e, no primeiro repinte, voltava pro texto
     chumbado neste arquivo, que envelhecia sozinho. Os outros ganchos
     continuam aqui porque nao existem no editor. */
  (function(){
    if (!cpbar) return;
    var ic = cpbar.querySelector('.ic'),
        tb = cpbar.querySelector('.txt b'),
        ts = cpbar.querySelector('.txt small'),
        ct = cpbar.querySelector('.cbuy');
    if (ic && ic.innerHTML.trim()) GANCHOS.buy.ic  = ic.innerHTML.trim();
    if (tb && tb.textContent.trim()) GANCHOS.buy.tit = tb.textContent.trim();
    if (ts) GANCHOS.buy.sub = ts.textContent.trim();
    if (ct) GANCHOS.buy.cta = ct.outerHTML;
  })();

  var ganchoAtual = null, ganchoAlvo = null, estreou = false, trocando = false, chamou = false;

  function pinta(k){
    var g = GANCHOS[k]; if(!g || !cpbar) return;
    cpbar.innerHTML =
      '<span class="ic" aria-hidden="true">' + g.ic + '</span>' +
      '<span class="txt"><b>' + g.tit + '</b><small>' + g.sub + '</small></span>' + g.cta;
    Tato.equipar(cpbar);        /* o botão é novo em folha: o switch vai junto */
  }

  function troca(k){
    if (!cpbar) return;
    ganchoAlvo = k;
    if (k === ganchoAtual || trocando) return;
    if (!estreou || !cpbar.classList.contains('show')) { ganchoAtual = k; pinta(k); return; }
    trocando = true;
    cpbar.classList.remove('reabre');
    cpbar.classList.add('recolhe');
    setTimeout(function(){
      ganchoAtual = k; pinta(k);
      cpbar.classList.add('reabre');
      cpbar.classList.remove('recolhe');
      setTimeout(function(){
        cpbar.classList.remove('reabre');
        trocando = false;
        /* enquanto trocava, a leitura pode ter passado pra outro bloco */
        if (ganchoAlvo !== ganchoAtual) troca(ganchoAlvo);
      }, 600);
    }, 250);
  }

  /* ── UMA BARRA SO, E ELA COMPRA — 30/09 (Raio-X, G3-2) ──────────────────
     A pilula trocava de funcao conforme a secao do meio da tela: "Calcular",
     depois nada, "Ver ficha", "Comparar", e so no fim "Comprar". Quem se
     convencia no meio da pagina nao tinha a compra ao alcance do polegar.
     Agora ela e sempre a de compra: aparece quando o botao de compra da
     pagina sai da tela e fica ate o fim. Calcular, ficha e comparar
     continuam como botoes dentro das proprias secoes.
     Quem decide se ela aparece e um IntersectionObserver no botao, nao a
     conta de rolagem: o navegador avisa quando ele entra ou sai, e a
     rolagem nao paga nada por isso (INP). Os ganchos antigos (`data-pill`
     nas secoes, GANCHOS acima) ficam no codigo, mas deixam de ser lidos. */
  var alvoCompra = document.querySelector('.spdp .buy.cpr .cpr-acoes');
  var compraNaTela = !!alvoCompra;
  var compraAbaixo = false;
  /* REGRA DA BARRA — 01/10 (Romulo): a barra fixa so aparece depois que o
     botao "Adicionar ao carrinho" da pagina ja saiu, praticamente inteiro,
     pelo TOPO da tela. Botao ainda abaixo da dobra ou na tela = sem barra.
     "Praticamente saiu" = sobra no maximo 20% dele visivel abaixo do
     cabecalho flutuante (72px), que ja o cobre. */
  var botaoCompra = document.querySelector('.spdp .buy.cpr [data-comprar]') || alvoCompra;
  var compraPassou = false;
  if (alvoCompra && 'IntersectionObserver' in window) {
    /* compraNaTela continua sendo o sinal do botao de suporte (classe no body) */
    new IntersectionObserver(function (ents) {
      var en = ents[ents.length - 1];
      compraNaTela = en.isIntersecting;
      applyScroll();
    }, { rootMargin: '0px 0px -84px 0px', threshold: 0 }).observe(alvoCompra);
    new IntersectionObserver(function (ents) {
      var en = ents[ents.length - 1];
      var r = en.boundingClientRect;
      compraPassou = r.top < 72 && en.intersectionRatio <= 0.2;
      applyScroll();
    }, { rootMargin: '-72px 0px 0px 0px', threshold: [0, 0.2, 0.5, 1] }).observe(botaoCompra);
  }

  /* a barra de compra chama o MESMO botao da pagina: com voltagem escolhida
     ele adiciona a sacola; sem, ele rola ate a voltagem e escreve o aviso.
     Sem botao na pagina (secao usada fora da PDP), volta a ser ancora. */
  document.addEventListener('click', function (e) {
    /* o "Comprar o <modelo>" do comparativo (G5-3) faz o mesmo caminho da
       barra: fecha o painel, se estiver dentro de um, e chama o botao da
       pagina — que rola ate a voltagem se ela ainda nao foi escolhida. */
    var aqui = e.target.closest('[data-comprar-aqui]');
    if (aqui) {
      var btn = document.querySelector('.spdp .buy.cpr [data-comprar]');
      if (!btn) return;                      /* sem botao: vale a ancora #comprar */
      e.preventDefault();
      var painel = aqui.closest('.tmodal.open');
      if (painel) Folha.fechar(painel);
      setTimeout(function () { btn.click(); }, painel ? 60 : 0);
      return;
    }
    var cb = e.target.closest('#buypill [data-pill-comprar]');
    if (!cb) return;
    var principal = document.querySelector('.spdp .buy.cpr [data-comprar]');
    if (principal) { e.preventDefault(); principal.click(); return; }
    var h = cb.getAttribute('data-href') || '#comprar';
    var alvo = h.charAt(0) === '#' ? document.querySelector(h) : null;
    if (alvo) alvo.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
    else if (h) location.href = h;
  });

  /* o bloco que ocupa o meio da tela é quem manda */
  var blocos = [].slice.call(document.querySelectorAll('section.sec'));
  var mudos  = [].slice.call(document.querySelectorAll('[data-pill-mute]'));
  /* a pílula só se cala quando o convite grande está de fato lido na tela —
     não basta ele espiar por baixo enquanto a pessoa ainda olha os cartazes */
  function temMudoNaTela(){
    for (var i = 0; i < mudos.length; i++){
      var r = mudos[i].getBoundingClientRect();
      var visivel = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (r.height > 0 && visivel / r.height >= 0.75) return true;
    }
    return false;
  }
  function ganchoDoMeio(){
    /* 30/09 (G3-2): a barra e sempre a de compra. O resto da funcao fica
       como registro de como os ganchos eram escolhidos. */
    if (cpbar) return 'buy';
    var meio = window.scrollY + vh / 2;
    for (var i = 0; i < blocos.length; i++){
      var r = blocos[i].getBoundingClientRect();
      var topo = r.top + window.scrollY;
      if (meio >= topo && meio < topo + r.height) return blocos[i].getAttribute('data-pill') || 'buy';
    }
    return 'buy';
  }

  function applyScroll(){
    ticking=false;
    if(!cpbar || cpbar.classList.contains('gone')) return;
    var y = window.scrollY;
    dh = document.documentElement.scrollHeight;
    var k = ganchoDoMeio();
    /* 30/09 (G3-2): visivel sempre que o botao de compra da pagina nao esta
       na tela — ate o fim da pagina. Chegando na pagina (topo), com o botao
       ainda abaixo da dobra, ela espera o primeiro gesto de rolagem. Sem o
       botao na pagina, vale a regra antiga de distancia. */
    var visivel = alvoCompra
      ? compraPassou
      : (k !== 'none' && y > 640 && (y + vh < dh - 460) && !temMudoNaTela());
    if (k !== 'none') troca(k);
    var jaEstava = cpbar.classList.contains('show');
    /* O BOTAO DE SUPORTE SAI DA FRENTE DA COMPRA — 30/09 (Raio-X, G2-11).
       Na PDP ele cobria os chips de voltagem e o proprio botao de compra.
       Regra: com a pilula na tela ele se acopla a ela (stellar-suporte ja
       faz isso); SEM a pilula — ou seja, com o botao de compra da pagina a
       vista — ele some. A classe no body e o sinal que a secao de suporte le
       em `sumir_quando`. So em pagina com botao de compra. */
    /* 01/10: a classe diz so se o BOTAO de compra esta na tela. Antes era o
       inverso da pilula, e no topo da pagina (pilula esperando o 1o gesto)
       o botao de suporte sumia sem motivo. */
    if (alvoCompra) document.body.classList.toggle('stl-compra-visivel', compraNaTela);
    cpbar.classList.toggle('show', visivel);
    if (visivel) estreou = true;
    /* o toque de chamada só na primeira ENTRADA em que ele pode existir:
       o navegador exige que a pessoa já tenha tocado na página, e rolar
       não conta. Se não puder, fica quieto e não tenta de novo à toa. */
    if (visivel && !jaEstava && !chamou && Tato.pronto()) {
      chamou = true;
      setTimeout(function(){ Tato.chamada(); }, 560);   /* junto do último tempo da coreografia */
    }
  }

  /* as ações que não são link reaproveitam os gatilhos que já existem na página */
  document.addEventListener('pointerdown', function(e){
    if (e.target.closest('#buypill .cbuy')) { Tato.medio(); return; }
    if (e.target.closest('[data-topen], [data-rclose], [data-tclose], .pxl-nav button, .sol-dots button, .gal-dots button, .sh-dots button, ' +
        '.cpr-esc:not([disabled]), .cpr-card-vira, .cpr-frete-abre, .dhl-dots button, .gal-thumbs button, .sfq__cat, .cpr-share')) Tato.leve();
  }, { passive: true });

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-act]'); if(!b) return;
    var act = b.getAttribute('data-act');
    if (act === 'roi'){ if (window.abrirROI) window.abrirROI(); }
    if (act === 'tech'){ var t = document.querySelector('[data-topen]'); if (t) t.click(); }
    if (act === 'cmp'){ var c = document.querySelector('.cmpg-abrir'); if (c) c.click(); }
  });
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(applyScroll); } }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){ vh=window.innerHeight; dh=document.documentElement.scrollHeight; },{passive:true});
  applyScroll();
  // Carrossel de embaixadores
  (function(){
    var tr=document.getElementById('ambTrack'); if(!tr) return;
    var prev=document.getElementById('ambPrev'), next=document.getElementById('ambNext');
    var amt=function(){ var c=tr.querySelector('.amb-card'); return c?c.offsetWidth+16:262; };
    if(prev) prev.addEventListener('click',function(){ tr.scrollBy({left:-amt(),behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ tr.scrollBy({left:amt(),behavior:'smooth'}); });
  })();
  // Decode assíncrono
  (function(){ document.querySelectorAll('img').forEach(function(im){ try{ im.decoding='async'; }catch(_){} }); })();
  // Revelação suave ao rolar (imersivo com moderação)
  (function(){
    if(REDUCE || !('IntersectionObserver' in window)) return;
    var sel=['.center','.sol-hero','.sol-item','.life .lc','.cmpx-head','.cmpx-card','.pcard','.jstep','.speccell','.hcard','.tech-shot','.proj','.vsh-note','.faqx-side','.qa','.benx-head','.benx-card','.closing','.lib-head'];
    var els=[];
    sel.forEach(function(s){ document.querySelectorAll(s).forEach(function(e){ if(els.indexOf(e)<0) els.push(e); }); });
    if(!els.length) return;
    els.forEach(function(e){ e.classList.add('reveal'); });
    ['.sol-list','.journey','.specgrid','.hair','.pb','.qa-list','.life','.benx-grid'].forEach(function(gs){
      document.querySelectorAll(gs).forEach(function(g){ var i=0; Array.prototype.forEach.call(g.children,function(c){ if(c.classList&&c.classList.contains('reveal')){ c.style.transitionDelay=(i*0.06)+'s'; i++; } }); });
    });
    var io=new IntersectionObserver(function(ents){ ents.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } }); },{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    els.forEach(function(e){ io.observe(e); });
  })();


/* hotspots sobre imagem */
(function(){
  document.querySelectorAll('[data-hotspots]').forEach(function(box){
    var pop=box.querySelector('.xpl-pop'), hots=box.querySelectorAll('.hot'), cur=null;
    if(!pop) return;
    function close(){ if(cur){cur.classList.remove('on');cur=null;} pop.classList.remove('show'); }
    hots.forEach(function(h){
      h.addEventListener('click',function(e){
        e.stopPropagation();
        if(cur===h){ close(); return; }
        hots.forEach(function(x){ x.classList.remove('on'); });
        h.classList.add('on'); cur=h;
        pop.querySelector('b').textContent=h.getAttribute('data-t');
        pop.querySelector('p').textContent=h.getAttribute('data-d');
        pop.classList.add('show');
      });
    });
    pop.addEventListener('click',function(e){ e.stopPropagation(); });
    document.addEventListener('click',close);
  });
})();
/* calculadora de retorno (modal) */
(function(){
  var modal=document.getElementById('roimodal'); if(!modal) return;
  var brl=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL',maximumFractionDigits:0});
  function g(id){return document.getElementById(id);}
  function upd(){
    var ticket=+g('ticket').value, extra=+g('extra').value, days=+g('days').value, price=+g('price').value;
    var monthly=ticket*extra*days;
    g('ticketLabel').textContent=brl.format(ticket);
    g('extraLabel').textContent=extra;
    g('daysLabel').textContent=days;
    g('priceLabel').textContent=brl.format(price);
    g('monthly').textContent=brl.format(monthly);
    if(extra>0){ var pd=Math.max(1,Math.ceil(price/(ticket*extra))); g('payback').textContent=pd+(pd===1?' dia':' dias'); }
    else { g('payback').textContent='—'; }
  }
  function pinta(el){
    var min = +el.min, max = +el.max;
    el.style.setProperty('--p', ((el.value - min) / (max - min) * 100) + '%');
  }
  ['ticket','extra','days','price'].forEach(function(id){
    var el = g(id);
    el.addEventListener('input', function(){ pinta(el); upd(); });
    pinta(el);
  });
  upd();
  function show(){ Folha.abrir(modal); }
  function hide(){ Folha.fechar(modal); }
  Folha.arrastavel(modal);
  window.abrirROI = show;          /* único caminho: a pílula */
  /* LINK DIRETO (07/10): stellarbeauty.com.br/products/secador-stellar-pro#calculadora
     abre a calculadora sozinha. Pedido do comercial, para mandar ao cliente.
     Mesmo padrão do #ficha: espera o layout assentar e limpa o hash. */
  function porHashROI(){
    if (!/^#(calculadora|retorno)$/.test(location.hash)) return;
    setTimeout(function(){
      show();
      history.replaceState(null, '', location.pathname + location.search);
    }, 320);
  }
  porHashROI();
  window.addEventListener('hashchange', porHashROI);
  modal.querySelectorAll('[data-rclose]').forEach(function(b){ b.addEventListener('click',hide); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && modal.classList.contains('open')) hide(); });
})();
/* o pôster que vira tela — bloco 01 */
(function(){
  var big = document.querySelector('[data-cat-big]');
  var runway = document.querySelector('[data-cat-runway]');
  if (!big || !runway) return;
  var sticky = runway.querySelector('.cat-sticky');
  var row = big.querySelector('[data-cat-pills]');
  var pills = [].slice.call(big.querySelectorAll('[data-cat-pill]'));
  var reduz = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ── abrir e fechar ────────────────────────────────────────────────
     A pill fechada tem a largura do próprio texto; aberta, a da coluna.
     Guardo a largura original em bytes no dataset porque depois de abrir
     não dá mais pra medir: o elemento já mudou de tamanho.               */
  function encolhe(el){
    if (!el.classList.contains('is-open')) return;
    var w0 = parseFloat(el.dataset.w0);
    el.style.width = el.offsetWidth + 'px';
    void el.offsetWidth;                       /* força o navegador a assumir a largura fixa */
    el.classList.add('is-closing');
    el.classList.remove('is-open');
    el.setAttribute('aria-expanded','false');
    el.style.width = w0 ? w0 + 'px' : '';
    setTimeout(function(){ el.classList.remove('is-closing'); }, 380);
  }
  function cresce(el){
    if (!el.dataset.w0) el.dataset.w0 = el.offsetWidth;
    el.style.width = el.dataset.w0 + 'px';
    void el.offsetWidth;
    el.classList.add('is-open');
    el.setAttribute('aria-expanded','true');
    el.style.width = row.clientWidth + 'px';
  }

  /* As pills de baixo são empurradas quando a de cima abre. Sem isto elas
     saltam; com isto, deslizam. Mede antes, muta, mede depois, e anima a
     diferença — a técnica que o pessoal de animação chama de FLIP.        */
  function desliza(muta){
    if (reduz) { muta(); return; }
    var antes = pills.map(function(p){ return p.getBoundingClientRect().top; });
    muta();
    pills.forEach(function(p,i){
      if (p.classList.contains('is-open') || p.classList.contains('is-closing')) return;
      var d = antes[i] - p.getBoundingClientRect().top;
      if (!d) return;
      p.style.transition = 'none';
      p.style.transform = 'translateY(' + d + 'px)';
      requestAnimationFrame(function(){
        p.style.transition = 'transform .52s cubic-bezier(.22,1,.36,1)';
        p.style.transform = '';
        setTimeout(function(){ p.style.transition = ''; p.style.transform = ''; }, 560);
      });
    });
  }
  function fechaTodas(){ desliza(function(){ pills.forEach(encolhe); }); }
  function abre(i){
    var alvo = null;
    pills.forEach(function(b){ if (b.dataset.i === i) alvo = b; });
    if (!alvo) return;
    if (alvo.classList.contains('is-open')) { desliza(function(){ encolhe(alvo); }); return; }
    desliza(function(){
      pills.forEach(function(b){ if (b !== alvo) encolhe(b); });
      cresce(alvo);
    });
  }
  pills.forEach(function(b){
    b.addEventListener('click', function(e){
      e.stopPropagation();
      big.dataset.tocou = '1';                 /* a partir daqui, quem manda é o dedo */
      if (window.Tato) window.Tato.leve();
      abre(b.dataset.i);
    });
  });
  document.addEventListener('click', function(e){ if (!big.contains(e.target)) fechaTodas(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') fechaTodas(); });
  window.addEventListener('resize', function(){
    pills.forEach(function(b){ if (b.classList.contains('is-open')) b.style.width = row.clientWidth + 'px'; });
  }, { passive:true });

  /* ── a expansão ────────────────────────────────────────────────────── */
  if (!sticky) return;
  var mq = window.matchMedia('(max-width: 900px)');
  var pre0 = parseFloat(runway.dataset.prestart); if (isNaN(pre0)) pre0 = 45;
  var fim = parseFloat(runway.dataset.finish);   if (isNaN(fim) || fim <= 0) fim = 50;
  var autoAbre = big.dataset.autoopen === '1';
  var pendente = false, abriu = false;

  function conta(){
    pendente = false;
    if (!mq.matches){
      big.style.removeProperty('--p'); sticky.style.removeProperty('--p');
      return;
    }
    var r = runway.getBoundingClientRect();
    var curso = r.height - sticky.offsetHeight; if (curso < 0) curso = 0;
    var pre = window.innerHeight * (pre0 / 100);
    var faixa = pre + curso * (fim / 100); if (faixa <= 0) faixa = 1;
    var p = (pre - r.top) / faixa;
    p = p < 0 ? 0 : (p > 1 ? 1 : p);
    big.style.setProperty('--p', p.toFixed(4));
    sticky.style.setProperty('--p', p.toFixed(4));

    if (!autoAbre) return;
    /* chegou na tela cheia: a primeira pill se apresenta sozinha — mas só
       se a pessoa ainda não tiver tocado em nenhuma. */
    if (p > 0.985 && !abriu){
      abriu = true;
      if (big.dataset.tocou !== '1') setTimeout(function(){
        if (big.dataset.tocou !== '1') abre('0');
      }, 320);
    }
    if (p < 0.5 && abriu){
      abriu = false;
      if (big.dataset.tocou !== '1') fechaTodas();
    }
  }
  function naRolagem(){ if (pendente) return; pendente = true; requestAnimationFrame(conta); }
  window.addEventListener('scroll', naRolagem, { passive:true });
  window.addEventListener('resize', naRolagem, { passive:true });
  requestAnimationFrame(conta);
})();
/* liberdade: a foto prende, o desfoque sobe, os cartões entram.

   Além dos três contadores de CSS, este bloco decide UMA coisa que o vídeo
   dos cartões precisa saber: se os cartões já subiram. Enquanto estão lá
   embaixo, translúcidos e fora de lugar, um vídeo rodando é filme passando
   pra plateia nenhuma — quando a pessoa finalmente vê o cartão, o loop já
   está no meio. Por isso o palco avisa, por evento, quando abre e quando
   fecha, e o vídeo só começa a partir daí.

   A abertura tem histerese de propósito: abre em 0,85 e só fecha abaixo de
   0,60. Sem isso, parar a rolagem exatamente na fronteira faria os vídeos
   piscarem entre tocar e pausar a cada pixel. */
(function(){
  function montar(pista){
    if (pista.dataset.libPronto) return;
    var pino = pista.querySelector('.lib-pin');
    if (!pino) return;
    pista.dataset.libPronto = '1';

    var pendente = false, aberto = false;

    /* um trecho de 0 a 1 recortado de dentro de outro: é assim que os dois
       tempos se sobrepõem sem precisar de dois contadores */
    function trecho(p, ini, fim){
      var v = (p - ini) / (fim - ini);
      return v < 0 ? 0 : (v > 1 ? 1 : v);
    }

    function conta(){
      pendente = false;
      var r = pista.getBoundingClientRect();
      var curso = r.height - pino.offsetHeight;
      if (curso <= 0) return;

      /* ANTECIPACAO
         Antes o contador so comecava quando o palco ja estava grudado no topo:
         a foto entrava nitida, parava, e so entao desfocava. Agora ele comeca
         `avanco` telas antes disso — a foto ja chega amaciando. O fim continua
         exatamente onde estava, entao o desfoque nao ficou mais rapido, ficou
         mais longo pra tras. */
      var avanco = (parseFloat(pista.getAttribute('data-lib-avanco')) || 0) / 100
                 * (window.innerHeight || 800);
      var total = curso + avanco;
      var p = (avanco - r.top) / total;
      p = p < 0 ? 0 : (p > 1 ? 1 : p);

      /* converte uma marca do tempo antigo (0..1 do trecho grudado) pro novo */
      function m(v){ return (avanco + v * curso) / total; }

      var c = trecho(p, m(0.16), m(0.56));
      pino.style.setProperty('--p', p.toFixed(4));
      pino.style.setProperty('--b', trecho(p, 0, m(0.28)).toFixed(4));
      pino.style.setProperty('--c', c.toFixed(4));

      var quer = aberto ? c > 0.60 : c >= 0.85;
      if (quer !== aberto){
        aberto = quer;
        pista.classList.toggle('lib-aberto', aberto);
        try {
          pista.dispatchEvent(new CustomEvent('lib:cartoes', { detail: { aberto: aberto } }));
        } catch (e) {
          var ev = document.createEvent('CustomEvent');
          ev.initCustomEvent('lib:cartoes', false, false, { aberto: aberto });
          pista.dispatchEvent(ev);
        }
      }
    }
    function naRolagem(){ if (pendente) return; pendente = true; requestAnimationFrame(conta); }
    window.addEventListener('scroll', naRolagem, { passive:true });
    window.addEventListener('resize', naRolagem, { passive:true });
    requestAnimationFrame(conta);
  }

  function iniciar(escopo){
    var alvo = escopo && escopo.querySelectorAll ? escopo : document;
    if (alvo.matches && alvo.matches('[data-lib-stage]')) return montar(alvo);
    [].slice.call(alvo.querySelectorAll('[data-lib-stage]')).forEach(montar);
  }

  iniciar(document);
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
/* jornada — saiba mais em modal translúcido */
(function(){
  var steps=document.querySelectorAll('.jstep'), modal=document.getElementById('jmodal');
  if(!steps.length || !modal) return;
  var mic=modal.querySelector('.mic'), met=modal.querySelector('.met'), mh=modal.querySelector('h3'), mp=modal.querySelector('p');
  function open(step){
    mic.innerHTML=step.querySelector('.node').innerHTML;
    met.textContent=step.querySelector('.et').textContent;
    mh.textContent=step.querySelector('h3').textContent;
    mp.textContent=step.getAttribute('data-tip')||'';
    Folha.abrir(modal);
  }
  function close(){ Folha.fechar(modal); }
  steps.forEach(function(s){ s.addEventListener('click',function(){ open(s); }); });
  modal.querySelectorAll('[data-jclose]').forEach(function(b){ b.addEventListener('click',close); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
})();


(function(){
  var b=document.getElementById('hmenuBtn'), p=document.getElementById('hmenuPop'); if(!b||!p) return;
  b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); p.classList.toggle('open'); });
  document.addEventListener('click',function(e){ if(!e.target.closest('.hmenu')) p.classList.remove('open'); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') p.classList.remove('open'); });
})();

/* ── GALERIA EM CELULAR ──────────────────────────────────────────────────
   Ate 920px o CSS esconde a foto principal e mostra `.gal-track` no lugar
   dela — so que ninguem preenchia essa pista, e a caixa da galeria ficava
   vazia. As miniaturas ja sao a fonte da verdade das fotos: e delas que a
   pista e os pontinhos sao montados.
   So roda abaixo de 920px: acima disso `.gal-track{display:contents}` faria
   as seis fotos vazarem por cima da principal. */
(function () {
  if (!window.matchMedia('(max-width:920px)').matches) return;
  var pista = document.getElementById('galtrack'),
      pontos = document.getElementById('galdots'),
      minis = document.getElementById('galthumbs'),
      principal = document.getElementById('galmain');
  if (!pista || !pontos || !minis) return;
  /* a primeira foto pode ja vir no HTML (data-ssr): ela e aproveitada como a
     primeira da pista e o resto e montado a partir da segunda */
  var jaVeio = pista.querySelector('img[data-ssr]');
  if (pista.children.length && !jaVeio) return;

  var botoes = [].slice.call(minis.querySelectorAll('button'));
  if (!botoes.length) return;

  botoes.forEach(function (b, i) {
    var src = b.getAttribute('data-src');
    if (!src) return;
    var mini = b.querySelector('img');
    var img = (i === 0 && jaVeio) ? jaVeio : document.createElement('img');
    if (img !== jaVeio) {
      var w = function (n) { return src.replace(/([?&])width=\d+/, '$1width=' + n); };
      img.srcset = w(500) + ' 500w, ' + w(800) + ' 800w, ' + w(1200) + ' 1200w, ' + src + ' 1600w';
      img.sizes = '100vw';
      img.src = src; img.decoding = 'async';
      img.loading = i ? 'lazy' : 'eager';
    }
    img.alt = (mini && mini.alt) || '';
    /* o ponto focal marcado no admin da Shopify viaja na miniatura e e
       aplicado aqui. Sem `data-foco`, vale a base — a regra do CSS. */
    var foco = b.getAttribute('data-foco');
    if (foco) img.style.objectPosition = foco;
    if (img.parentNode !== pista) pista.appendChild(img);

    var d = document.createElement('button');
    d.type = 'button';
    d.setAttribute('role', 'tab');
    d.setAttribute('aria-label', 'Foto ' + (i + 1));
    if (!i) d.className = 'on';
    pontos.appendChild(d);
  });

  var fotos = [].slice.call(pista.children),
      bolas = [].slice.call(pontos.children),
      atual = 0;

  /* O FUNDO DESFOCADO ATRAS DO CABECALHO.

     A moldura e mais alta que a foto de proposito, pra pilula do cabecalho
     flutuar sobre alguma coisa que nao seja o produto. Essa "alguma coisa" e
     a propria foto, de novo: uma segunda copia em `cover`, desfocada, atras
     da pista. Emenda nenhuma, porque nao ha duas imagens — ha uma, duas vezes.

     Nasce no JS e nao no Liquid porque so existe abaixo de 920px, que e onde
     este trecho inteiro roda. No computador a foto preenche a moldura e o
     fundo nao teria o que mostrar.

     `decoding=async` + `loading=eager`: ela e a primeira coisa que a pessoa
     ve atras da barra, entao nao pode chegar depois — mas tambem nao pode
     travar o desenho da foto de verdade. */
  var caixaFundo = document.createElement('div');
  caixaFundo.className = 'gal-fundo';
  caixaFundo.setAttribute('aria-hidden', 'true');
  var espelho = document.createElement('span');
  /* uma copia de cada foto, lado a lado, na mesma largura da pista de baixo:
     assim a faixa pode andar junto com o dedo em vez de trocar de imagem
     quando o gesto termina. As fotos ja estao no cache do navegador — sao os
     mesmos `src` da pista —, entao isto nao pede nada de rede. */
  var faixaFundo = document.createElement('div');
  faixaFundo.className = 'gal-fundo-pista';
  espelho.appendChild(faixaFundo);
  caixaFundo.appendChild(espelho);

  /* O DESFOQUE SAO DUAS CAMADAS, E NAO UM FILTRO SO.

     `backdrop-filter` nao servia: ele borra o que foi pintado ATRAS da
     camada, e o espelho e irmao dela dentro da mesma faixa — ficava fora do
     alcance. Media 14px de desfoque e nao mexia num pixel. Por isso o disco
     do controle aparecia inteiro, espelhado, boiando acima do cabecalho.

     `filter: blur()` borra de verdade, mas esvanece as PROPRIAS bordas: o
     que passa por elas e o degrade claro da moldura, e numa foto de fundo
     escuro as laterais da faixa saem cinza-claras (medido: 153 e 180 contra
     107 da foto).

     Entao vao as duas: o espelho nitido embaixo, que da o tom certo de ponta
     a ponta, e uma copia borrada por cima. Onde o borrao esvanece, quem
     aparece e o nitido — mesmo tom, sem buraco. No miolo, que e onde as
     formas incomodam, so se ve o borrao. */
  var espelhoB = espelho.cloneNode(false);
  espelhoB.className = 'gal-fundo-borrao';
  var faixaB = document.createElement('div');
  faixaB.className = 'gal-fundo-pista';
  espelhoB.appendChild(faixaB);
  caixaFundo.appendChild(espelhoB);

  pista.parentNode.insertBefore(caixaFundo, pista);
  /* AS FOTOS PRECISAM SER POSTAS A MAO, JA.

     A faixa atras do cabecalho nao pode nascer vazia — so com o degrade da
     moldura — e ganhar imagem depois do primeiro gesto. Ninguem repara no
     que aparece; repara-se no que aparece TARDE. */
  fotos.forEach(function (f) {
    [faixaFundo, faixaB].forEach(function (onde) {
      var c = document.createElement('img');
      c.alt = '';
      c.decoding = 'async';
      onde.appendChild(c);
      /* so copia quando a foto da pista ja carregou: ai sim sai do cache (mesma currentSrc) */
      var copia = function () { c.src = f.currentSrc || f.src; };
      if (f.complete && f.naturalWidth) copia();
      else f.addEventListener('load', copia, { once: true });
    });
  });

  /* o unico ponto que move a faixa. Anda em pixel, nao em indice: e o mesmo
     deslocamento da pista de baixo, entao as duas camadas nunca se separam,
     nem no meio do gesto, nem quando o dedo passa do ponto e volta. */
  /* AS DUAS CAMADAS ANDAM, MAS DE JEITOS DIFERENTES.

     A nitida move a pista de DENTRO: e barato, o navegador so desloca o
     conteudo.

     A borrada NAO pode fazer isso. Mexer num filho de um elemento com
     `filter` obriga o navegador a refazer o desfoque a cada quadro — 26px
     sobre meia tela, sessenta vezes por segundo. Era isso que atrasava a
     faixa quando a foto trocava.

     Entao ela move a SI MESMA. Um elemento filtrado com `will-change`
     ganha camada propria: deslocar a camada ja pronta e so composicao, e o
     desfoque nao roda de novo.

     O DESLOCAMENTO E O MESMO NAS DUAS, SEM DIVIDIR PELA ESCALA.

     Foi o erro de uma primeira versao: como o translate vem por ultimo na
     lista, parece que ele anda no sistema ja aumentado e que por isso
     deveria andar menos. So que o CONTEUDO tambem esta aumentado — a foto
     numero i nasce 1,4x mais longe do centro. As duas ampliacoes se anulam
     e sobra o mesmo `x` da camada nitida.

     Dividir por 1,4 deixava a faixa 0,4 x 390px atras por foto: certa na
     primeira, quase uma foto inteira fora na setima. */
  var ESCALA = 1.4;
  function seguirFundo() {
    var x = -pista.scrollLeft;
    faixaFundo.style.transform = 'translate3d(' + x + 'px,0,0)';
    espelhoB.style.transform =
      'scaleY(-1) scale(' + ESCALA + ') translate3d(' + x + 'px,0,0)';
  }
  /* pista recem-montada: scrollLeft e 0, nao precisa ler o layout. O scroll da pista chama seguirFundo depois. */
  faixaFundo.style.transform = 'translate3d(0px,0,0)';
  espelhoB.style.transform = 'scaleY(-1) scale(' + ESCALA + ') translate3d(0px,0,0)';

  function pintar(i) {
    atual = i;
    bolas.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    botoes.forEach(function (b, k) { b.classList.toggle('on', k === i); });
    if (principal && fotos[i]) {
      principal.src = fotos[i].src;
      principal.style.objectPosition = fotos[i].style.objectPosition || '';
    }
  }
  function ir(i) {
    if (!fotos[i]) return;
    var destino = fotos[i].offsetLeft - fotos[0].offsetLeft;
    /* fotos em cartão (01/10): o cartão para depois das miniaturas, no
       `scroll-padding-left` da pista; a 1ª continua encostada na borda */
    if (i > 0) destino -= parseFloat(getComputedStyle(pista).scrollPaddingLeft) || 0;
    try { pista.scrollTo({ left: destino, behavior: 'smooth' }); }
    catch (e) { pista.scrollLeft = destino; }
    pintar(i);
  }
  bolas.forEach(function (d, i) { d.addEventListener('click', function () { ir(i); }); });
  botoes.forEach(function (b, i) { b.addEventListener('click', function () { ir(i); }); });

  /* Antes isto era um debounce de 110ms: os pontinhos so trocavam 110ms
     DEPOIS de a pessoa parar de arrastar, e o atraso era visivel. Agora a
     conta roda no proximo quadro de desenho — o pontinho acompanha o dedo.
     O `pedido` evita empilhar varios rAF quando o evento de scroll dispara
     muitas vezes dentro do mesmo quadro. */
  var pedido = 0;
  pista.addEventListener('scroll', function () {
    seguirFundo();          /* fora do rAF: a faixa nao pode ficar um quadro atras do dedo */
    if (pedido) return;
    pedido = requestAnimationFrame(function () {
      pedido = 0;
      var meio = pista.getBoundingClientRect().left + pista.clientWidth / 2,
          melhor = 0, menor = Infinity;
      fotos.forEach(function (f, k) {
        var r = f.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - meio);
        if (d < menor) { menor = d; melhor = k; }
      });
      if (melhor !== atual) {
        pintar(melhor);
        /* O TIQUE DA GALERIA.
           Cada foto que assume o centro da pista devolve um toque curto — e a
           leitura de "engatou" que os seletores do iOS usam. Vale no arrasto e
           no pontinho, porque os dois passam por aqui.
           No iPhone isto nao acontece: o Safari nunca implementou a vibracao,
           e o truque do switch nativo (o que a pagina usa nos botoes) so
           dispara em TOQUE DIRETO — a Apple fechou a chamada por codigo no
           iOS 26.5. Num arrasto nao existe toque direto no switch. */
        if (window.Tato) window.Tato.leve();
      }
    });
  }, { passive: true });
})();

/* ── SETAS DAS PISTAS DE "NA PRÁTICA" E "LIBERDADE" ──────────────────────
   Os dois pares de botão existiam no HTML desde sempre, com ícone e tudo,
   e nenhum listener: clicar não fazia nada. Só o carrossel de embaixadores
   tinha o seu. Mesma mecânica dele, escrita uma vez para os dois.
   O passo é a largura real do primeiro cartão + o gap real da pista — não
   um número chutado, senão a foto para no meio do caminho. */
(function () {
  [['pxlprev', 'pxlnext', 'pxltrack', '.pxl-card'],
   ['libprev', 'libnext', 'libtrack', '.lib-card']].forEach(function (t) {
    var antes = document.getElementById(t[0]),
        depois = document.getElementById(t[1]),
        pista = document.getElementById(t[2]);
    if (!pista || (!antes && !depois)) return;

    function passo() {
      var c = pista.querySelector(t[3]);
      if (!c) return Math.round(pista.clientWidth * 0.85);
      var gap = parseFloat(getComputedStyle(pista).columnGap || getComputedStyle(pista).gap) || 0;
      return Math.round(c.getBoundingClientRect().width + gap);
    }
    function anda(dir) {
      var d = dir * passo();
      try { pista.scrollBy({ left: d, behavior: 'smooth' }); }
      catch (e) { pista.scrollLeft += d; }
    }
    if (antes) antes.addEventListener('click', function () { anda(-1); });
    if (depois) depois.addEventListener('click', function () { anda(1); });

    /* botão que não leva a lugar nenhum fica apagado: no fim da pista o
       "próximo" não tem para onde ir, e o inverso no começo. */
    function pintar() {
      var max = pista.scrollWidth - pista.clientWidth - 2;
      if (antes) antes.disabled = pista.scrollLeft <= 2;
      if (depois) depois.disabled = pista.scrollLeft >= max;
    }
    pista.addEventListener('scroll', pintar, { passive: true });
    window.addEventListener('resize', pintar, { passive: true });
    pintar();
  });
})();

/* ── COMECE PELOS DESTAQUES ──────────────────────────────────────────────
   Pista que anda so no dedo. Os pontinhos sao construidos a partir dos
   cards e servem pra duas coisas: dizer onde a pessoa esta e levar direto
   a um slide. Sem avanco automatico e sem botao de pausa.

   O editor de tema redesenha a secao inteira a cada tecla e a cada foto
   trocada — e o HTML novo volta sem nenhum ouvinte. Por isso o montador
   vive numa funcao propria, protegida por uma marca no elemento, e roda de
   novo em shopify:section:load. Sem isso os pontinhos somem no primeiro
   ajuste e a secao parece morta enquanto a pessoa edita. */
(function () {
  function montar(pista) {
    if (pista.dataset.dhlPronto) return;
    var secao = pista.closest('.sec') || document;
    var cards = [].slice.call(pista.querySelectorAll('.dhl-card')),
        caixa = secao.querySelector('[data-dhl-dots]');
    if (!cards.length || !caixa) return;
    pista.dataset.dhlPronto = '1';

    var i = 0;

    caixa.innerHTML = '';
    cards.forEach(function (c, k) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Ir para o destaque ' + (k + 1));
      d.addEventListener('click', function () { irPara(k); });
      caixa.appendChild(d);
    });
    var pontos = [].slice.call(caixa.children);

    function pintar() { pontos.forEach(function (d, k) { d.classList.toggle('on', k === i); }); }

    function irPara(k) {
      i = (k + cards.length) % cards.length;
      var destino = cards[i].offsetLeft - cards[0].offsetLeft;
      try { pista.scrollTo({ left: destino, behavior: 'smooth' }); }
      catch (e) { pista.scrollLeft = destino; }
      pintar();
    }

    /* qual card esta encostado na borda de entrada da pista. O atalho do fim
       existe porque o ultimo card encaixa pela direita: sem ele, o ponto certo
       nunca acende no fim da rolagem. */
    function foco() {
      if (pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 2) return cards.length - 1;
      var pl = parseFloat(getComputedStyle(pista).paddingLeft) || 0,
          alvo = pista.getBoundingClientRect().left + pl,
          melhor = 0, menor = Infinity;
      cards.forEach(function (c, k) {
        var d = Math.abs(c.getBoundingClientRect().left - alvo);
        if (d < menor) { menor = d; melhor = k; }
      });
      return melhor;
    }

    var t;
    pista.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { i = foco(); pintar(); }, 110);
    }, { passive: true });

    pintar();
  }

  function iniciar(escopo) {
    var alvo = escopo && escopo.querySelectorAll ? escopo : document;
    if (alvo.matches && alvo.matches('[data-dhl-rail]')) return montar(alvo);
    [].slice.call(alvo.querySelectorAll('[data-dhl-rail]')).forEach(montar);
  }

  iniciar(document);
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();

/* ── ÂNCORAS DENTRO DA PÁGINA ────────────────────────────────────────────
   As seções usam `content-visibility:auto`: enquanto o alvo ainda não foi
   renderizado, a altura dele é um palpite do navegador. O salto de âncora
   mira nesse palpite e, quando o conteúdo real entra, o destino já mudou de
   lugar — o link "Assistir ao vídeo" parava 1.866 px antes da seção.
   Aqui a gente deixa o salto nativo acontecer (o CSS quer suave), espera ele
   parar e só então corrige o resto. Rolagem da pessoa cancela na hora. */
(function () {
  if (!document.querySelector('.spdp')) return;

  document.addEventListener('click', function (e) {
    var a = e.target.closest('.spdp a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var alvo = document.getElementById(id);
    if (!alvo) return;

    var cancelado = false;
    function solta() { cancelado = true; }
    window.addEventListener('wheel', solta, { passive: true, once: true });
    window.addEventListener('touchstart', solta, { passive: true, once: true });

    var ultimo = -1, parado = 0, fim = performance.now() + 4000;
    (function assenta() {
      if (cancelado) return;
      var y = window.pageYOffset;
      if (Math.abs(y - ultimo) < 1) parado++; else parado = 0;
      ultimo = y;

      if (parado > 3) {
        var d = alvo.getBoundingClientRect().top;
        if (Math.abs(d) > 2) {
          try { window.scrollBy({ top: d, left: 0, behavior: 'instant' }); }
          catch (err) { window.scrollBy(0, d); }
          parado = 0;
          ultimo = -1;
        } else {
          window.removeEventListener('wheel', solta);
          window.removeEventListener('touchstart', solta);
          return;
        }
      }
      if (performance.now() < fim) requestAnimationFrame(assenta);
      else { window.removeEventListener('wheel', solta); window.removeEventListener('touchstart', solta); }
    })();
  });
})();

/* embaixadores em vídeo: pontinhos, só o slide da frente toca, e o som */
(function () {

  function montar(rail) {
    if (!rail || rail.dataset.ebPronto) return;
    rail.dataset.ebPronto = '1';

    var secao  = rail.closest('.eb');
    var pontos = secao.querySelector('[data-eb-dots]');
    var botao  = secao.querySelector('[data-eb-som]');
    var slides = [].slice.call(rail.children);
    var videos = [].slice.call(rail.querySelectorAll('video.eb-video'));
    if (!slides.length) return;

    /* pontinhos nascem do número de slides — o Liquid não precisa contar */
    pontos.innerHTML = '';
    var bolas = slides.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Ir para o embaixador ' + (i + 1));
      if (i === 0) b.className = 'on';
      b.addEventListener('click', function () {
        var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        rail.scrollTo({ left: slides[i].offsetLeft - pad, behavior: 'smooth' });
      });
      pontos.appendChild(b);
      return b;
    });

    function foco() {
      var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      var melhor = 0, dist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - pad - rail.scrollLeft);
        if (d < dist) { dist = d; melhor = i; }
      }
      /* o último nunca chega a zero: o encaixe dele é pela direita */
      if (rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2) melhor = slides.length - 1;
      for (var k = 0; k < bolas.length; k++) bolas[k].classList.toggle('on', k === melhor);
    }
    var pendente = false;
    rail.addEventListener('scroll', function () {
      if (pendente) return; pendente = true;
      requestAnimationFrame(function () { pendente = false; foco(); });
    }, { passive: true });
    foco();

    if (!videos.length) return;

    /* SÓ O SLIDE DA FRENTE TEM VÍDEO — 02/10, refeito.
       O observador antigo usava a própria fileira como raiz: media só o
       lado, nunca a tela. O vídeo da frente tocava em loop mesmo com a
       seção fora de vista (desde o carregamento da página), e os seis
       vídeos nasciam com src e preload. Medido no iPhone com o Romulo:
       vídeo carregado, mesmo parado, pesa a rolagem da página inteira.
       Agora: nenhum vídeo tem endereço até ser o da frente; só um por vez;
       ele só entra com a seção na tela e a rolagem parada; quem deixa de
       ser o da frente, ou a seção saindo da tela, devolve o arquivo. */
    var daFrente = null, naTela = false, relogio = 0;
    function solta(v) {
      if (!v) return;
      var sl = v.closest('.eb-slide'); if (sl) sl.classList.remove('eb-tocando');
      if (!v.getAttribute('src')) return;
      try { v.pause(); } catch (e) {}
      v.removeAttribute('src');
      try { v.load(); } catch (e) {}
    }
    videos.forEach(function (v) {
      v.addEventListener('playing', function () {
        var sl = v.closest('.eb-slide'); if (sl && v === daFrente) sl.classList.add('eb-tocando');
      });
    });
    function liga(v) {
      if (!v.getAttribute('src')) {
        var u = v.getAttribute('data-src') || v.getAttribute('data-orig');
        if (!u) return;
        v.src = u;
        v.addEventListener('error', function () {
          var o = v.getAttribute('data-orig');
          if (o && v.getAttribute('src') && v.getAttribute('src') !== o) { v.src = o; var q = v.play(); if (q && q.catch) q.catch(function(){}); }
        }, { once: true });
      }
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    }
    function decide() {
      relogio = 0;
      var alvo = null;
      if (naTela && !document.hidden) {
        var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        var melhor = 0, dist = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var d = Math.abs(slides[i].offsetLeft - pad - rail.scrollLeft);
          if (d < dist) { dist = d; melhor = i; }
        }
        if (rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2) melhor = slides.length - 1;
        alvo = slides[melhor].querySelector('video.eb-video');
      }
      if (alvo === daFrente) { if (alvo && alvo.paused) liga(alvo); return; }
      solta(daFrente);
      daFrente = alvo;
      if (alvo) liga(alvo);
    }
    function mexeu() {
      clearTimeout(relogio);
      relogio = setTimeout(decide, 260);
    }
    rail.addEventListener('scroll', mexeu, { passive: true });
    window.addEventListener('scroll', function () { if (naTela) mexeu(); }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) { if (daFrente) { try { daFrente.pause(); } catch (e) {} } } else if (naTela) mexeu(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          naTela = e.isIntersecting;
          /* fora da tela o vídeo da frente só PAUSA, no quadro em que estava:
             descartar e recarregar a cada saída fazia a imagem voltar ao
             primeiro quadro, e no iPhone parecia um zoom indo e voltando */
          if (naTela) mexeu(); else { clearTimeout(relogio); if (daFrente) { try { daFrente.pause(); } catch (e) {} } }
        });
      }, { threshold: 0.2 }).observe(rail);
    } else { naTela = true; mexeu(); }

    /* o autoplay só é permitido no mudo — e depoimento mudo é foto que mexe */
    if (botao) {
      botao.hidden = false;
      var ligado = false;
      var desligadoTxt = botao.querySelector('span').textContent;
      var ligadoTxt = botao.getAttribute('data-on') || 'Som ligado';
      botao.addEventListener('click', function () {
        ligado = !ligado;
        videos.forEach(function (v) { v.muted = !ligado; });
        botao.querySelector('[data-eb-mudo]').style.display  = ligado ? 'none' : '';
        botao.querySelector('[data-eb-ondas]').style.display = ligado ? '' : 'none';
        botao.querySelector('span').textContent = ligado ? ligadoTxt : desligadoTxt;
        botao.setAttribute('aria-label', ligado ? 'Desativar som' : 'Ativar som');
      });
    }
  }

  function iniciar(escopo) {
    var raiz = escopo || document;
    if (raiz.matches && raiz.matches('[data-eb-rail]')) return montar(raiz);
    [].forEach.call(raiz.querySelectorAll('[data-eb-rail]'), montar);
  }

  iniciar(document);

  /* DENTRO DO EDITOR DE TEMAS
     A cada campo que a pessoa digita, a Shopify redesenha a seção inteira e
     joga fora este JS: os pontinhos sumiam, o vídeo parava de tocar e o
     botão de som ficava escondido — parecia que a edição não tinha pegado.
     O evento abaixo remonta só a seção que voltou. */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();


/* ── OLHE DE PERTO · vídeo no lugar da foto ──────────────────────────────
   Só UM vídeo toca por vez: o protagonista, que é o cartão com a maior
   fatia visível da pista. Antes bastava aparecer 45% pra tocar, e o cartão
   seguinte — aquele que espia pela direita de propósito, pra dizer que a
   pista anda — começava junto. A pessoa via movimento na borda enquanto
   lia o cartão do meio, e quando chegava nele o filme já ia pela metade.

   Duas condições continuam valendo:
   1. os cartões já subiram — o palco avisa por evento (lib:cartoes);
   2. o protagonista precisa de pelo menos 60% de si mesmo na pista, senão
      ninguém toca (estado de transição entre um cartão e outro).

   A repetição é contada aqui, não delegada ao atributo `loop`: com loop
   nativo o evento `ended` nunca dispara e não haveria como saber a hora de
   parar. Depois de N voltas o cartão descansa — a capa cobre o último quadro
   e um play pequeno aparece pra quem quiser rever.

   Todo vídeo que assume o posto volta pro primeiro quadro e zera a contagem.
   É o que faz a leitura em sequência funcionar: ninguém pega filme pela
   metade, nem o primeiro nem o sexto.

   O autoplay mudo pode ser recusado (bateria, política do navegador); o
   play() devolve promessa e a recusa é engolida de propósito: o cartaz
   continua no lugar e ninguém vê buraco. */
(function () {
  var PISO = 0.6;

  function montar(pista) {
    if (pista.dataset.libVideoPronto) return;
    var filmes = [].slice.call(pista.querySelectorAll('[data-lib-video]'));
    if (!filmes.length) return;
    pista.dataset.libVideoPronto = '1';

    var palco = pista.closest('[data-lib-stage]');
    var aberto = palco ? palco.classList.contains('lib-aberto') : true;
    var temOlho = 'IntersectionObserver' in window;
    var limite = parseInt(pista.getAttribute('data-lib-voltas'), 10);
    if (!(limite > 0)) limite = 2;

    function caixa(v) { return v.closest('[data-lib-palco]') || v.parentNode; }

    function velocidade(v) {
      var n = parseFloat(v.getAttribute('data-vel'));
      if (!(n > 0)) n = 100;
      try { v.playbackRate = n / 100; } catch (e) {}
    }

    /* 02/10 · TOQUE PESADO NO IPHONE (medido com o Romulo no aparelho): o
       custo era ter os vídeos CARREGADOS ao mesmo tempo. Agora só o vídeo
       que toca tem endereço; quem sai de cena devolve o arquivo e mostra o
       cartaz. E nenhum vídeo começa com o dedo rolando a página. */
    function carregar(v) {
      if (v.getAttribute('src') || !v.getAttribute('data-src')) return;
      v.src = v.getAttribute('data-src');
      v.addEventListener('error', function () {
        var o = v.getAttribute('data-orig');
        if (o && v.getAttribute('src') !== o) v.src = o;
      }, { once: true });
    }
    function soltar(v) {
      if (!v.getAttribute('src') || !v.getAttribute('poster')) return;
      try { v.pause(); } catch (e) {}
      v.removeAttribute('src');
      try { v.load(); } catch (e) {}
    }

    function rodar(v) {
      carregar(v);
      velocidade(v);
      caixa(v).classList.remove('parado');
      try { v.currentTime = 0; } catch (e) {}
      var t = v.play();
      if (t && t.catch) t.catch(function () {});
    }

    function descansar(v) {
      var c = caixa(v);
      v.pause();
      /* sem capa não há o que cobrir: rebobina pra não descansar num quadro
         qualquer do meio do movimento */
      if (!c.querySelector('.lib-capa')) { try { v.currentTime = 0; } catch (e) {} }
      c.classList.add('parado');
      if (c.querySelector('.lib-capa')) soltar(v);
    }

    filmes.forEach(function (v) {
      velocidade(v);
      v.voltas = 0;
      v.fatia = temOlho ? 0 : 1;
      v.addEventListener('ended', function () {
        v.voltas++;
        if (v.voltas < limite) {
          try { v.currentTime = 0; } catch (e) {}
          var t = v.play();
          if (t && t.catch) t.catch(function () {});
        } else {
          descansar(v);
        }
      });
      var botao = caixa(v).querySelector('[data-lib-replay]');
      if (botao) botao.addEventListener('click', function () { v.voltas = 0; rodar(v); });
    });

    /* o cartão mais visível da pista, se estiver visível o bastante */
    function protagonista() {
      var alvo = null, maior = 0;
      filmes.forEach(function (v) {
        if (v.fatia > maior) { maior = v.fatia; alvo = v; }
      });
      return maior >= PISO ? alvo : null;
    }

    var atual = null;
    var naTela = !temOlho, ultimaRolagem = 0, espera = 0;
    window.addEventListener('scroll', function () { ultimaRolagem = Date.now(); }, { passive: true });

    function aplicar() {
      var desde = Date.now() - ultimaRolagem;
      if (naTela && desde < 260) { clearTimeout(espera); espera = setTimeout(aplicar, 280 - desde); return; }
      var alvo = (aberto && naTela) ? protagonista() : null;

      if (alvo !== atual) {
        /* quem perdeu o posto volta pro começo: se a pessoa voltar pra ele,
           encontra o filme inteiro, não o resto de onde parou */
        if (atual) {
          atual.pause();
          atual.voltas = 0;
          caixa(atual).classList.remove('parado');
          try { atual.currentTime = 0; } catch (e) {}
          soltar(atual);
        }
        atual = alvo;
        if (alvo) { alvo.voltas = 0; rodar(alvo); }
      }

      /* rede de segurança: ninguém além do protagonista pode estar tocando */
      filmes.forEach(function (v) {
        if (v !== atual && !v.paused) v.pause();
      });
    }

    if (temOlho) {
      var passos = [];
      for (var i = 0; i <= 20; i++) passos.push(i / 20);
      var olho = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) { e.target.fatia = e.intersectionRatio; });
        aplicar();
      }, { root: pista, threshold: passos });
      filmes.forEach(function (v) { olho.observe(v); });
      /* a pista como raiz só mede o lado; isto mede se ela está na tela */
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { naTela = e.isIntersecting; });
        aplicar();
      }, { threshold: 0.25 }).observe(pista);
    }

    if (palco) {
      palco.addEventListener('lib:cartoes', function (e) {
        aberto = !!(e.detail && e.detail.aberto);
        if (!aberto && atual) {
          atual.pause();
          atual.voltas = 0;
          caixa(atual).classList.remove('parado');
          try { atual.currentTime = 0; } catch (e2) {}
          soltar(atual);
          atual = null;
        }
        aplicar();
      });
    }

    aplicar();
  }

  function iniciar(escopo) {
    var alvo = escopo && escopo.querySelectorAll ? escopo : document;
    if (alvo.matches && alvo.matches('.lib-track')) return montar(alvo);
    [].slice.call(alvo.querySelectorAll('.lib-track')).forEach(montar);
  }

  iniciar(document);
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();


/* ── BRILHO SO QUANDO IMPORTA ─────────────────────────────────────────────
   Os gradientes que passam pelo texto (.grad, os numeros da ficha, os do
   "Olhe de perto", a aba ativa, o nome no comparativo) animam
   background-position. Isso NAO e acelerado por composicao: o navegador
   redesenha o recorte de cada glifo em TODO quadro.

   Medido nesta pagina, no trecho "Por dentro": 12 desses elementos na tela
   ao mesmo tempo, 35 animacoes rodando na pagina inteira, e o tempo de
   tarefa da thread principal durante a rolagem caindo de 22,6% para 14,6%
   quando tudo era pausado. Um terco do custo da rolagem era brilho.

   Entao o brilho para em dois casos, sem mudar o desenho:
     · fora da tela — ninguem esta vendo;
     · enquanto o dedo rola — a volta leva 7s, ninguem sente falta dela
       durante o gesto, e e exatamente ai que o quadro precisa do folego.
   Pausar e retomar continua de onde parou, entao nao ha salto.            */
(function () {
  var raiz = document.documentElement;

  var t;
  window.addEventListener('scroll', function () {
    if (!raiz.classList.contains('rolando')) raiz.classList.add('rolando');
    clearTimeout(t);
    t = setTimeout(function () { raiz.classList.remove('rolando'); }, 180);
  }, { passive: true });

  if (!window.IntersectionObserver) return;
  var ALVOS = '.spdp .grad, .spdp .speccell .v, .spdp .lib-num b, ' +
              '.spdp .tdc-cap i, .spdp .cmpx-name, .spdp .hot, ' +
              '.spdp .vch-st.grande .vch-n';
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (e) { e.target.classList.toggle('fora', !e.isIntersecting); });
  }, { rootMargin: '140px' });

  function equipar(raizEl) {
    (raizEl || document).querySelectorAll(ALVOS).forEach(function (el) { io.observe(el); });
  }
  equipar(document);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) equipar(e.target);
  });
})();

/* ── A FOTO EM TELA CHEIA ────────────────────────────────────────────────
   A foto do produto e o argumento mais caro da pagina, e ate agora ela
   morria em 390px de largura. Tocar nela abre a tela cheia.

   A fonte da verdade continua sendo `#galthumbs`: e dela que a galeria do
   celular ja monta a pista e os pontinhos, entao a tela cheia le a mesma
   lista e nao inventa uma terceira copia das fotos.

   Tres coisas nao obvias:

   1. O indice VOLTA pra pagina ao fechar. Se a pessoa navegou ate a quinta
      foto em tela cheia e fecha, a galeria da pagina tambem esta na quinta —
      senao o gesto de fechar desfaz silenciosamente o que ela acabou de
      fazer. A sincronia e feita clicando na miniatura, que e quem os dois
      desenhos (celular e computador) ja escutam.

   2. Arrastar pra baixo fecha, e leva a foto junto. E o gesto que a maioria
      tenta primeiro. Mas o mesmo dedo tambem troca de foto pro lado, entao a
      primeira dezena de pixels decide o eixo e ele nao muda mais ate o dedo
      sair — sem isso, um arrasto na diagonal disputa os dois ao mesmo tempo
      e nenhum acontece direito.

   3. As fotos entram em `src` so quando alguem abre. Sao seis imagens de
      1600px; carregar todas junto com a pagina custaria mais do que a tela
      cheia inteira vale pra quem nunca abre. */
(function () {
  var minis = document.getElementById('galthumbs');
  if (!minis) return;
  var origens = [].slice.call(minis.querySelectorAll('button')).map(function (b) {
    return b.getAttribute('data-src');
  }).filter(Boolean);
  if (origens.length < 1) return;

  var veu = null, pista = null, pontos = null, conta = null, figs = [], bolas = [];
  var atual = 0, aberto = false, rolagemY = 0;

  function indiceDaPagina() {
    var d = document.querySelector('.gal-dots button.on');
    if (d) return [].indexOf.call(d.parentNode.children, d);
    var m = minis.querySelector('button.on');
    if (m) return [].indexOf.call(minis.children, m);
    return 0;
  }

  function svg(caminho, largura) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' +
      largura + '" stroke-linecap="round" stroke-linejoin="round"><path d="' + caminho + '"/></svg>';
  }

  function montar() {
    veu = document.createElement('div');
    veu.className = 'galzoom';
    veu.setAttribute('role', 'dialog');
    veu.setAttribute('aria-modal', 'true');
    veu.setAttribute('aria-label', 'Fotos do produto');

    var dentro = document.createElement('div');
    dentro.className = 'galzoom-in';

    pista = document.createElement('div');
    pista.className = 'galzoom-pista';
    origens.forEach(function (src, i) {
      var f = document.createElement('div');
      f.className = 'galzoom-fig';
      var img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      img.dataset.src = src;
      f.appendChild(img);
      pista.appendChild(f);
    });

    pontos = document.createElement('div');
    pontos.className = 'galzoom-pontos';
    origens.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Foto ' + (i + 1));
      d.addEventListener('click', function () { ir(i); });
      pontos.appendChild(d);
    });

    dentro.appendChild(pista);
    dentro.appendChild(pontos);

    conta = document.createElement('span');
    conta.className = 'galzoom-conta';

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'galzoom-x';
    x.setAttribute('aria-label', 'Fechar');
    x.innerHTML = svg('M7 7l10 10M17 7L7 17', 2.2);
    x.addEventListener('click', fechar);

    var ant = document.createElement('button');
    ant.type = 'button';
    ant.className = 'galzoom-seta ant';
    ant.setAttribute('aria-label', 'Foto anterior');
    ant.innerHTML = svg('M14.5 5.5L8 12l6.5 6.5', 2);
    ant.addEventListener('click', function () { ir(atual - 1); });

    var dep = document.createElement('button');
    dep.type = 'button';
    dep.className = 'galzoom-seta dep';
    dep.setAttribute('aria-label', 'Próxima foto');
    dep.innerHTML = svg('M9.5 5.5L16 12l-6.5 6.5', 2);
    dep.addEventListener('click', function () { ir(atual + 1); });

    veu.appendChild(dentro);
    veu.appendChild(conta);
    veu.appendChild(x);
    if (origens.length > 1) { veu.appendChild(ant); veu.appendChild(dep); }
    document.body.appendChild(veu);

    figs = [].slice.call(pista.children);
    bolas = [].slice.call(pontos.children);
    veu.setas = [ant, dep];

    /* o pontinho segue o dedo no mesmo quadro, igual a galeria da pagina */
    var pedido = 0;
    pista.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = requestAnimationFrame(function () {
        pedido = 0;
        var meio = pista.getBoundingClientRect().left + pista.clientWidth / 2,
            melhor = 0, menor = Infinity;
        figs.forEach(function (f, k) {
          var r = f.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - meio);
          if (d < menor) { menor = d; melhor = k; }
        });
        if (melhor !== atual) {
          pintar(melhor);
          if (window.Tato) window.Tato.leve();   /* o mesmo tique da pista, na tela cheia */
        }
      });
    }, { passive: true });

    arrastar(dentro);
    veu.addEventListener('click', function (e) {
      /* o fundo preto ao redor da foto tambem fecha */
      if (e.target === pista || e.target.classList.contains('galzoom-fig')) fechar();
    });
  }

  function carregar(i) {
    [i - 1, i, i + 1].forEach(function (k) {
      var f = figs[k];
      if (!f) return;
      var img = f.firstChild;
      if (img && !img.src && img.dataset.src) img.src = img.dataset.src;
    });
  }

  function pintar(i) {
    atual = i;
    bolas.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    conta.textContent = (i + 1) + ' / ' + origens.length;
    if (veu.setas) {
      veu.setas[0].disabled = i === 0;
      veu.setas[1].disabled = i === origens.length - 1;
    }
    carregar(i);
  }

  function ir(i) {
    if (i < 0 || i >= figs.length) return;
    carregar(i);
    var destino = figs[i].offsetLeft - figs[0].offsetLeft;
    try { pista.scrollTo({ left: destino, behavior: 'smooth' }); }
    catch (e) { pista.scrollLeft = destino; }
    pintar(i);
  }

  function abrir(i) {
    if (aberto) return;
    if (!veu) montar();
    aberto = true;
    rolagemY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.style.overflow = 'hidden';
    carregar(i);
    /* posicionar SEM animacao antes de o veu aparecer: com scroll suave a
       tela cheia abriria na primeira foto e so entao deslizaria ate a certa */
    pista.scrollLeft = figs[i].offsetLeft - figs[0].offsetLeft;
    pintar(i);
    veu.style.opacity = '';
    requestAnimationFrame(function () { veu.classList.add('on'); });
  }

  function fechar() {
    if (!aberto) return;
    aberto = false;
    veu.classList.remove('on');
    document.documentElement.style.overflow = '';
    window.scrollTo(0, rolagemY);
    var alvo = minis.children[atual];
    if (alvo) alvo.click();
    var v = veu.querySelector('.galzoom-in');
    setTimeout(function () { if (v) v.style.transform = ''; }, 300);
  }

  /* ARRASTAR PRA BAIXO FECHA.
     O eixo e decidido nos primeiros 10px de movimento e nao muda mais ate o
     dedo sair: sem isso um arrasto na diagonal disputa a troca de foto e o
     fechar ao mesmo tempo, e nenhum dos dois acontece direito. */
  function arrastar(alvo) {
    var x0 = 0, y0 = 0, eixo = '', dy = 0;
    alvo.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      eixo = ''; dy = 0;
      alvo.style.transition = 'none';
    }, { passive: true });

    alvo.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - x0;
      dy = e.touches[0].clientY - y0;
      if (!eixo) {
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
        eixo = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
      }
      if (eixo !== 'y' || dy < 0) return;
      e.preventDefault();
      alvo.style.transform = 'translateY(' + dy + 'px) scale(' + (1 - Math.min(dy, 400) / 2600) + ')';
      veu.style.opacity = String(Math.max(0, 1 - dy / 520));
    }, { passive: false });

    alvo.addEventListener('touchend', function () {
      alvo.style.transition = 'transform .3s cubic-bezier(.32,.72,0,1)';
      if (eixo === 'y' && dy > 96) {
        /* a opacidade fica no inline ate o fim: devolver ela pro CSS aqui
           faria o veu saltar pra 1 por um quadro antes de sumir */
        alvo.style.transform = 'translateY(60vh)';
        veu.style.opacity = '0';
        fechar();
      } else {
        veu.style.opacity = '';
        alvo.style.transform = '';
      }
      eixo = ''; dy = 0;
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!aberto) return;
    if (e.key === 'Escape') fechar();
    else if (e.key === 'ArrowRight') ir(atual + 1);
    else if (e.key === 'ArrowLeft') ir(atual - 1);
  });

  /* o clique e delegado porque a pista do celular so e preenchida depois,
     por outro trecho deste arquivo — no momento em que este roda ela pode
     ainda estar vazia. */
  document.addEventListener('click', function (e) {
    var alvo = e.target.closest ? e.target.closest('.gal-main img') : null;
    if (!alvo) return;
    if (e.target.closest('.cpr-saiba')) return;
    e.preventDefault();
    abrir(indiceDaPagina());
  });
})();

/* ── O DISCO DO CONTROLE, NA FICHA TECNICA ─────────────────────────────
   O HTML chega com o disco E com a legenda inteira das sete funcoes. Este
   trecho recolhe a legenda para um painel e faz o disco responder ao
   toque. A ordem importa: quem nao tem JavaScript — e o rastreador do
   Google — fica com a lista completa, que e a versao honesta.

   O painel nasce do primeiro botao (o centro), que ja vem com `on` do
   Liquid. Assim nao existe um quadro em que a caixa esta vazia. */
(function () {
  var ctl = document.querySelector('.tctl');
  if (!ctl) return;
  var disco = ctl.querySelector('[data-disco]'),
      legenda = ctl.querySelector('[data-legenda]'),
      conta = ctl.querySelector('[data-conta]'),
      toque = ctl.querySelector('[data-toque]');
  if (!disco || !legenda) return;

  var bts = [].slice.call(disco.querySelectorAll('[data-bt]'));
  if (!bts.length) return;

  /* o painel entra no lugar da legenda, nao depois dela: a lista sai de
     cena inteira, senao a pessoa leria a mesma coisa duas vezes. */
  var painel = document.createElement('div');
  painel.className = 'tctl-painel';
  painel.setAttribute('role', 'status');
  painel.setAttribute('aria-live', 'polite');
  painel.innerHTML = '<div class="cab"><span class="ic"></span><b></b></div><p></p>';
  legenda.parentNode.insertBefore(painel, legenda);
  legenda.hidden = true;
  if (conta) conta.hidden = false;

  var pIc = painel.querySelector('.ic'),
      pTit = painel.querySelector('b'),
      pTxt = painel.querySelector('p'),
      pN = conta ? conta.querySelector('b') : null;

  function escolher(g) {
    bts.forEach(function (x) { x.classList.remove('on'); });
    g.classList.add('on');
    pTit.textContent = g.getAttribute('data-t') || '';
    pTxt.textContent = g.getAttribute('data-d') || '';
    /* o icone do painel e o MESMO glifo do disco, clonado — nao uma
       segunda arte que pode divergir com o tempo. */
    var glifo = g.querySelector('.glifo');
    pIc.innerHTML = glifo ? glifo.innerHTML : '';
    if (pN) pN.textContent = bts.indexOf(g) + 1;
    /* o convite ja cumpriu o papel */
    disco.classList.remove('chamando');
    if (toque) toque.classList.add('some');
    if (window.Tato) window.Tato.leve();
  }

  bts.forEach(function (g) {
    g.addEventListener('click', function () { escolher(g); });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); escolher(g); }
    });
  });

  /* pinta o painel com o botao que ja veio aceso, sem contar como toque */
  (function () {
    var inicial = disco.querySelector('[data-bt].on') || bts[0];
    pTit.textContent = inicial.getAttribute('data-t') || '';
    pTxt.textContent = inicial.getAttribute('data-d') || '';
    var glifo = inicial.querySelector('.glifo');
    pIc.innerHTML = glifo ? glifo.innerHTML : '';
    if (pN) pN.textContent = bts.indexOf(inicial) + 1;
  })();

  /* A BATIDA SO COMECA QUANDO O DISCO APARECE.
     Dentro de um modal fechado ela rodaria no vazio e a pessoa abriria a
     ficha depois da festa ter acabado. */
  if ('IntersectionObserver' in window) {
    var olho = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) {
          if (!disco.getAttribute('data-chamou')) {
            disco.classList.add('chamando');
            disco.setAttribute('data-chamou', '1');
          }
          olho.unobserve(en.target);
        }
      });
    }, { threshold: 0.4 });
    olho.observe(disco);
  } else {
    disco.classList.add('chamando');
  }
})();

/* ── MEDICAO POR ETAPA DA PDP — 30/09 (Raio-X, Fase 6: G2-22 / GA-4 / GA-9) ──
   Hoje o GA4 so sabe que a pessoa entrou e, as vezes, que pos na sacola: o
   meio (viu o preco? escolheu a voltagem? abriu o frete?) nao existia. Aqui
   a pagina so ANUNCIA cada etapa no window.dataLayer; quem transforma isso
   em evento do GA4 e o GTM (gatilho "Evento personalizado" com o nome
   abaixo). Nada de GA4, GTM ou app foi configurado daqui.

   Eventos (todos levam `produto` = id do produto e `produto_nome` = o H1):
     preco_visto          o bloco de preco entrou na tela pela 1a vez (o
                          "price_in_view" do GA-4), com `segundos` desde a
                          abertura da pagina
     voltagem_escolhida   `voltagem` = "127V" | "220V", `esgotada` = true|false
     cor_escolhida        `cor` = nome da bolinha tocada (Rosa, Verde...)
     barra_fixa_tocada    o "Comprar" da barra de baixo; `com_voltagem`
     frete_consultado     a consulta do CEP terminou; `resultado` = ok|erro.
                          O CEP NUNCA vai junto (dado da pessoa).
     faq_aberta           `pergunta` = texto da pergunta aberta (ate 100)
     comparativo_aberto   o painel One x PRO abriu
     secao_vista          `secao` = nome da secao do template, uma vez cada
     compra_sem_voltagem  ja existia (stellar-pro-compra), nao e repetido aqui

   POR QUE CADA PUSH LEVA `stl_n` (um contador): o app Wascer troca o
   dataLayer.push por uma versao que DESCARTA qualquer evento cujo JSON seja
   identico a um ja enviado na pagina. Sem o contador, a segunda escolha de
   127V (127 → 220 → 127) sumiria calada. O numero nao identifica ninguem:
   e so a ordem do evento dentro desta visita a pagina.

   LEVE E SEGURO, DE PROPOSITO:
   · nenhum listener novo por elemento: um clique delegado no documento, em
     fase de bolha e passivo — nunca chama preventDefault, nunca atrasa o
     toque. O push em si vai para quando o navegador estiver livre
     (requestIdleCallback, com teto de 2s), porque o GTM processa o push na
     mesma hora e isso nao pode cair dentro do quadro do toque (INP).
     A excecao e a cor: a bolinha e um link para a outra PDP, e um push
     adiado morreria com a pagina — ele sai na hora.
   · voltagem e frete sao lidos por MutationObserver no atributo que o script
     da compra ja muda (aria-checked / hidden): pega toque, teclado e a barra
     fixa sem encostar no codigo da compra.
   · marcos de leitura e preco: IntersectionObserver, desligado sozinho
     depois de ver cada coisa uma vez. Sem IO (navegador antigo), nao mede.
   · tudo dentro de try/catch: medicao que quebra nao pode quebrar a pagina. */
(function () {
  var caixa = document.querySelector('.spdp .buy.cpr');
  if (!caixa) return;                               /* so na PDP */

  var t0 = Date.now();
  var seq = 0;
  var h1 = caixa.querySelector('h1');
  var base = {
    produto: caixa.getAttribute('data-produto') || '',
    produto_nome: h1 ? (h1.textContent || '').replace(/\s+/g, ' ').trim() : ''
  };

  function monta(nome, extra) {
    /* o contador e o da pagina inteira (window.__stlSeq), dividido com o
       header_compre_ja_click do cabecalho — correcoes F1, 01/10 */
    seq = window.__stlSeq = (window.__stlSeq || 0) + 1;
    var ev = { event: nome, stl_n: seq };
    var k;
    for (k in base) ev[k] = base[k];
    if (extra) for (k in extra) ev[k] = extra[k];
    return ev;
  }
  function empurra(ev) {
    try { (window.dataLayer = window.dataLayer || []).push(ev); } catch (_) {}
  }
  var ocioso = window.requestIdleCallback
    ? function (fn) { window.requestIdleCallback(fn, { timeout: 2000 }); }
    : function (fn) { setTimeout(fn, 1); };
  /* monta ja (o contador guarda a ordem real), envia quando der */
  function envia(nome, extra) {
    var ev = monta(nome, extra);
    ocioso(function () { empurra(ev); });
  }

  /* "110V", "110/127v", "127 V" → "127V": o nome errado da variante nao
     entra na medicao (G5-14 / vocabulario da marca). */
  function volt(v) {
    v = String(v || '');
    if (/220/.test(v)) return '220V';
    if (/11\d|12\d/.test(v)) return '127V';
    return v.replace(/\s+/g, ' ').trim();
  }
  function temVoltagem() {
    return !!caixa.querySelector('#volt .cpr-esc[aria-checked="true"]');
  }

  /* ── cliques (delegado, passivo) ── */
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;

      var cor = t.closest('#cor .cpr-esc[data-cor]');
      if (cor) {
        if (!cor.classList.contains('on')) empurra(monta('cor_escolhida', { cor: cor.getAttribute('data-cor') || '' }));
        return;
      }
      if (t.closest('#buypill [data-pill-comprar], #buypill .cbuy')) {
        envia('barra_fixa_tocada', { com_voltagem: temVoltagem() });
        return;
      }
      if (t.closest('[data-abre^="cmpmodal-"]')) {
        envia('comparativo_aberto');
        return;
      }
      /* FAQ: o script da secao ja abriu/fechou quando o clique chega aqui
         (a lista escuta antes do documento). So conta quando ABRIU. */
      var q = t.closest('.sfq__q, .qa button');
      if (q) {
        var item = q.closest('[data-sfq-item]') || q.parentElement;
        var aberta = item && (item.classList.contains('is-on') || item.classList.contains('open'));
        if (aberta) envia('faq_aberta', { pergunta: (q.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100) });
      }
    } catch (_) {}
  }, { passive: true });

  if (!('MutationObserver' in window)) return;

  /* ── voltagem: o chip que passa a aria-checked="true" ── */
  var grupo = caixa.querySelector('#volt');
  if (grupo) {
    try {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          var el = ms[i].target;
          if (el.getAttribute('aria-checked') === 'true' && ms[i].oldValue !== 'true') {
            envia('voltagem_escolhida', {
              voltagem: volt(el.getAttribute('data-volt')),
              esgotada: el.hasAttribute('data-esgotado')
            });
            return;
          }
        }
      }).observe(grupo, { subtree: true, attributes: true, attributeFilter: ['aria-checked'], attributeOldValue: true });
    } catch (_) {}
  }

  /* ── frete: o resultado (ou o erro) que deixa de estar escondido ── */
  var frete = caixa.querySelector('[data-frete]') || document.querySelector('[data-frete]');
  if (frete) {
    var res = frete.querySelector('[data-frete-res]');
    var err = frete.querySelector('[data-frete-erro]');
    try {
      var mo = new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          var el = ms[i].target;
          if (ms[i].oldValue !== null && !el.hidden) {
            envia('frete_consultado', { resultado: el === res ? 'ok' : 'erro' });
            return;
          }
        }
      });
      [res, err].forEach(function (el) {
        if (el) mo.observe(el, { attributes: true, attributeFilter: ['hidden'], attributeOldValue: true });
      });
    } catch (_) {}
  }

  if (!('IntersectionObserver' in window)) return;

  /* ── preco_visto: metade do bloco de preco na tela, uma vez ── */
  var preco = caixa.querySelector('[data-stl-preco]') || caixa.querySelector('.cpr-precos') || caixa.querySelector('.cpr-val');
  if (preco) {
    try {
      var olhoPreco = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          if (ents[i].isIntersecting) {
            olhoPreco.disconnect();
            envia('preco_visto', { segundos: Math.round((Date.now() - t0) / 1000) });
            return;
          }
        }
      }, { threshold: 0.5 });
      olhoPreco.observe(preco);
    } catch (_) {}
  }

  /* ── secao_vista: o topo da secao passou de 60% da altura da tela ──
     Threshold 0 com a margem de baixo recolhida em vez de "x% da secao
     visivel": numa secao mais alta que 4 telas, 25% dela nunca cabe na
     tela e o marco nunca dispararia. O nome e a chave da secao no template
     ("pro_faq_v2", "pro_risco"...), sem o sufixo aleatorio do editor. */
  function nomeSecao(el) {
    var id = el.id || '';
    var chave = id.indexOf('__') > -1 ? id.split('__').pop() : id.replace('shopify-section-', '');
    return chave.replace(/_[A-Za-z0-9]{6}$/, '');
  }
  var secoes = [].slice.call(document.querySelectorAll('main .shopify-section, #MainContent .shopify-section'));
  if (!secoes.length) secoes = [].slice.call(document.querySelectorAll('.shopify-section[id*="template--"]'));
  if (secoes.length) {
    try {
      var vistas = {};
      var olhoSec = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          olhoSec.unobserve(en.target);
          var nome = nomeSecao(en.target);
          if (!nome || vistas[nome]) return;
          vistas[nome] = 1;
          envia('secao_vista', { secao: nome });
        });
      }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
      secoes.forEach(function (s) { if (s.offsetHeight > 0) olhoSec.observe(s); });
    } catch (_) {}
  }
})();
